module.exports = __webpack_public_path__ + "static/media/temp3.414a686f.png";